import { create } from 'zustand'

import { supplierService, type SupplierListItem } from '@/modules/suppliers/services'
import type {
  SupplierDashboard,
  SupplierFilters,
  SupplierPermissions,
} from '@/modules/suppliers/types'

interface SupplierStoreState {
  ready: boolean
  suppliers: SupplierListItem[]
  dashboard: SupplierDashboard
  filters: SupplierFilters
  permissions: SupplierPermissions
  selectedId: string | null

  hydrate: () => Promise<void>
  setFilters: (filters: Partial<SupplierFilters>) => void
  setSelectedId: (id: string | null) => void
  setPermissions: (patch: Partial<SupplierPermissions>) => void
  refresh: () => void
}

export const useSupplierStore = create<SupplierStoreState>((set, get) => ({
  ready: false,
  suppliers: [],
  dashboard: { total: 0, connected: 0, disconnected: 0, needLogin: 0 },
  filters: { activeOnly: false },
  permissions: supplierService.getPermissions(),
  selectedId: null,

  hydrate: async () => {
    await supplierService.ensureReady()
    const filters = get().filters
    set({
      ready: true,
      suppliers: supplierService.list(filters),
      dashboard: supplierService.dashboard(filters),
      permissions: supplierService.getPermissions(),
    })
  },

  setFilters: (filters) => {
    const next = { ...get().filters, ...filters }
    set({
      filters: next,
      suppliers: supplierService.list(next),
      dashboard: supplierService.dashboard(next),
    })
  },

  setSelectedId: (id) => set({ selectedId: id }),

  setPermissions: (patch) => {
    const permissions = supplierService.setPermissions(patch)
    set({ permissions })
  },

  refresh: () => {
    const filters = get().filters
    set({
      suppliers: supplierService.list(filters),
      dashboard: supplierService.dashboard(filters),
    })
  },
}))
